import { createFileRoute } from "@tanstack/react-router";
import { ThemeProvider } from "@repo/mfe-core";
import IspmUsers from "../../../pages/IspmUsers";

export const Route = createFileRoute("/admin/ispm-users/")({
  component: () => (
    <ThemeProvider>
      <IspmUsers />
    </ThemeProvider>
  ),
});
